import React from 'react'
import classes from '../CustomInputs.module.css';
import { Button } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const TextEditorInput = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    if (event.target.textContent !== '') {
      execCommand(event, "fontSize", +event.target.textContent);
    } 

    setAnchorEl(null);
  };

  const execCommand = (event, cmd, arg) => {
    event.preventDefault();
    document.execCommand(cmd, false, arg);
  }

  return (
    <>
        <div className={classes.editorContainer}>         
          <Button onClick={(event) => execCommand(event, 'bold')} sx={{minWidth: '20px', padding: '10px'}}><span style={{color: 'gray', fontWeight: 'bold'}}>B</span></Button>
          <Button onClick={(event) => execCommand(event, 'underline')} sx={{minWidth: '20px', padding: '10px'}}><span style={{color: 'gray', textDecoration: 'underline'}}>U</span></Button>
          <Button onClick={(event) => execCommand(event, 'italic')} sx={{minWidth: '20px', padding: '10px'}}><span style={{color: 'gray', fontStyle: 'italic'}}>I</span></Button>
          
          <Button
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            sx={{minWidth: '20px', padding: '10px'}}
            onClick={handleClick}
          >
            <span style={{fontWeight: 'bold', color: 'rgb(137, 134, 250)'}}>A</span>
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
          {Array.from(Array(7).keys()).map(
            (value) => <MenuItem key={value} onClick={handleClose}>{value + 1}</MenuItem>
          )}
      </Menu>
        </div>
    </>
  )
}

export default TextEditorInput;